import { render, staticRenderFns } from "./UCModal.vue?vue&type=template&id=92a6af0c&scoped=true&"
import script from "./UCModal.vue?vue&type=script&lang=ts&"
export * from "./UCModal.vue?vue&type=script&lang=ts&"
import style0 from "./UCModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UCModal.vue?vue&type=style&index=1&id=92a6af0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a6af0c",
  null
  
)

export default component.exports